// Relative Imports
import { Container } from "./styles";

const Grid = ({ rows, children }) => {
  return <Container rows={rows}>{children}</Container>;
};

export default Grid;
